import { render } from "./exam-list.vue?vue&type=template&id=12c4999e"
import script from "./exam-list.vue?vue&type=script&lang=js"
export * from "./exam-list.vue?vue&type=script&lang=js"

import exportComponent from "E:\\ceonline_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__